module.exports = __webpack_public_path__ + "media/SOC/gender-28139f2b.svg";